{
  "help": {
    "label": "How to read the wind forecast",
    "text": "Forecast wind 10 m above the ground, for now. Colours show its speed, as on weather stations; the moving streaks show where the air flows. Forecasts are for areas a few km across, so wind in valleys and around ridges can be quite different."
  },
  "scale": "Wind speed scale",
  "credit": "Forecast by <link>Open-Meteo</link>",
  "errors": {
    "service": "Couldn't load the wind forecast. Trying again as you move the map."
  }
}
